import { Select, SelectItem, Spinner } from "@heroui/react";
import { BOARDS_KEY_MAPPER_ENUM, TASKS_COLUMNS } from "@onesolution/constants";
import { useLanguage } from "@onesolution/hooks";
import type { TranslationsKeys } from "@onesolution/hooks/useLanguage";
import { getStatusChoicesFromServer } from "@onesolution/serverFn";
import { updateTaskStatusOnServer } from "@onesolution/serverFn/operations/updateTaskStatus";
import Chip from "../Chip";

export function StatusSelector(props: { value: string; taskId: string }) {
	const { t } = useLanguage();
	const statusChoicesQuery = getStatusChoicesFromServer.useQuery({
		boardId: BOARDS_KEY_MAPPER_ENUM.tasks,
		columnId: TASKS_COLUMNS.status,
	});
	const { isPending, mutate } = updateTaskStatusOnServer.useMutation();

	if (!statusChoicesQuery.data?.length) return null;

	return (
		<Select
			value={[props.value]}
			onChange={(e) => {
				mutate({ status: e.target.value, id: props.taskId });
			}}
			defaultSelectedKeys={[props.value]}
			items={statusChoicesQuery.data || []}
			classNames={{
				trigger:
					"p-0 min-h-0 h-auto bg-transparent shadow-none border-none w-min",
				selectorIcon: "hidden",
				popoverContent: "w-auto",
				base: "w-auto",
				innerWrapper: "p-0 w-min",
				value: "flex justify-end items-end w-full",
				mainWrapper: "p-0",
			}}
			renderValue={(selection: object[]) => {
				const item = selection[0] as { textValue: string; key: string };
				const label =
					t(`status.${item.textValue}` as TranslationsKeys, {
						skeleton: false,
					}) || item.textValue;

				if (isPending) return <Spinner color="default" />;

				return (
					<Chip
						radius="sm"
						key={item.key}
						variant="dot"
						className="cursor-pointer ml-auto in"
						classNames={{
							dot: `bg-[${item.key}]`,
						}}
					>
						{label}
					</Chip>
				);
			}}
		>
			{(selection: object) => {
				const item = selection as { name: string; key: string };
				const label =
					t(`status.${item.name}` as TranslationsKeys, {
						skeleton: false,
					}) || item.name;

				return (
					<SelectItem textValue={label}>
						<Chip
							radius="sm"
							variant="dot"
							className="pointer-events-none"
							classNames={{
								dot: `bg-[${item.key}]`,
							}}
						>
							{label}
						</Chip>
					</SelectItem>
				);
			}}
		</Select>
	);
}
